import * as csx from 'csx';

// Colors values are based off of value from RAUL 3 and may need to be updated on future versions
// https://dev-design.realpage.com/raul/theme/colors
const RAUL_THEME = {
  primary: '#0076cc',
  secondary: '#f06000',
  success: '#139c3e',
  warning: '#fec12d',
  error: '#d01a1f',
  white: '#ffffff',
  blueDark: '#202737',
  charcoal: '#494d50',
  greyLight: '#ebedee',
  greyDark: '#9ba3a7',
  greyLightest: '#f7f8f9',
  foreground: '#37474f',
};

const primary = RAUL_THEME.primary;
const secondary = RAUL_THEME.secondary;

const foreground = RAUL_THEME.foreground;
const foregroundHelper = csx.color(foreground);
const foregroundLighter = `${foregroundHelper.lighten(.1)}`;
const foregroundLight = RAUL_THEME.white;

const background = RAUL_THEME.white;
const greyBackground = RAUL_THEME.greyLight;
const darkBlueBackground = RAUL_THEME.blueDark;

const info = RAUL_THEME.primary;
const error = RAUL_THEME.error;
const success = RAUL_THEME.success;
const warning = RAUL_THEME.warning;

const disabledBackground = RAUL_THEME.greyLight;
const disabledText = RAUL_THEME.greyDark;

const white = RAUL_THEME.white;
const black = RAUL_THEME.charcoal;

const colors = {
  primary,
  secondary,
  foreground,
  foregroundLighter,
  foregroundLight,
  background,
  greyBackground,
  darkBlueBackground,
  info,
  error,
  success,
  warning,
  disabledBackground,
  disabledText,
  white,
  black,
};

export default colors;
